import { UploadFile } from 'antd';
import { FieldPath, FieldPathValue, Validate } from 'react-hook-form';

import { GrispiFile } from '../src/components/QuillGrispiRichTextEditor/components/UploadController';
import { TICKET_FORM_FIELDS_KEY, channelType } from '../src/model/types';

export const PublicVisibleTypeMap = {
    public: 'public',
    internal: 'internal'
} as const;
export type PublicVisibleType = keyof typeof PublicVisibleTypeMap;

interface GrispiPersistableFormBaseValues {
    currentAttachments: { inlineImages: { id: number; src: string }[]; attachments: GrispiFile[] };
    formName: string; // easy reference for setting attachmentIds
}
export interface CreateTicketFormValues extends GrispiPersistableFormBaseValues {
    comment: {
        attachmentIds?: number[];
        channel: channelType;
        body: string;
        creator: { key: 'us.id' | 'us.email' | 'us.phone'; value: string }[];
        publicVisible: boolean;
    };
    [TICKET_FORM_FIELDS_KEY]: Record<string, string | number>;
}
export interface EditTicketFormValues extends GrispiPersistableFormBaseValues {
    channel: channelType;
    comment?: {
        attachmentIds?: number[];
        body: string;
        channel: channelType;
        creator: { key: 'us.id' | 'us.email' | 'us.phone'; value: string }[];
        externalId?: number;
        publicVisible: boolean;
    };
    [TICKET_FORM_FIELDS_KEY]: Record<string, string | number>;
}
export interface EndUserRequestFormValues
    extends Omit<CreateTicketFormValues, 'comment' | typeof TICKET_FORM_FIELDS_KEY | 'formName'> {
    comment: {
        body: string;
        channel: channelType;
        creator: { key: 'us.email' | 'us.full_name' | 'us.phone'; value: string }[];
        publicVisible: boolean;
    };
    [TICKET_FORM_FIELDS_KEY]?: Record<string, string | number | UploadFile[]>;
}

export type TicketFormValues = CreateTicketFormValues | EditTicketFormValues;
export type TicketFormValidateType<T> = Validate<FieldPathValue<T, FieldPath<T>>, T>;
export type ITicketFormValidation<T> = {
    grispiRequiredRules?: TicketFormValidateType<T>;
    isValid?: TicketFormValidateType<T>;
    minTwoChars?: TicketFormValidateType<T>;
};
